/* eslint-disable
    import-x/no-mutable-exports,
    no-var,
    one-var,
    vars-on-top
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import {MaybeCoreObject} from 'app-core/framework/CoreObjectConstants';
import {getArchiveAction, getUnarchiveAction} from 'archive/ArchiveActionsUtil';
import {MaybeArchivableItem} from 'archive/ArchiveConstants';
import * as ArchiveModal from 'archive/components/modals/ArchiveModal';
import isArchivable from 'archive/isArchivable';
import isArchived from 'archive/isArchived';
import {assert} from 'Asserts';
import {StandardFeature} from 'auth/capabilities/CapabilityConstants';
import {RegistryFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isBiologicsOwnedItem} from 'auth/capabilities/getCapabilityFeatures';
import {FeatureDefinition} from 'auth/feature-enablement/FeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import isCollaboratable from 'auth/isCollaboratable';
import {Permissions} from 'auth/PermissionConstants';
import BenchlingConfig from 'BenchlingConfig';
import * as BenchlingUtil from 'BenchlingUtil';
import * as PoliceableActions from 'collaborator-components/PoliceableActions';
import * as contextmenu from 'components/ContextMenu';
import * as ExportConstants from 'constants/ExportConstants';
import * as FileBrowserConstants from 'constants/FileBrowserConstants';
import * as FolderConstants from 'constants/FolderConstants';
import ModelTypeConstants, {NOTEBOOK_ITEMS, COPYABLE_FOLDER_ITEMS} from 'constants/ModelTypeConstants';
import {FinderResult} from 'constants/NavConstants';
import {getRegistrySupportedTypes, RegistrySupportedType, TagSchema} from 'constants/RegistryConstants';
import * as SourceConstants from 'constants/SourceConstants';
import {Source, SourceSummary} from 'constants/SourceConstants';
import EntryDAO from 'dao/EntryDAO';
import ExportModalClass from 'exports/ExportModal';
import * as SourceActions from 'file-browser/SourceActions';
import CloneModal from 'folder-items/CloneModal';
import FilesForDeleteModalClass from 'folder-items/FilesForDeleteModal';
import normalizeFolder from 'folders/util/normalizeFolder';
import listFolderSection from 'nav/sidepanel/listFolderSection';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import * as SidepanelReduxActions from 'nav/sidepanel/SidepanelReduxActions';
import notifications from 'notifications';
import * as DeleteUtil from 'permissions/DeleteUtil';
import preferences from 'Preferences';
import {getStore} from 'redux-stores/Store';
import RegistryActions from 'registry/RegistryActions';
import * as RegistryUtil from 'registry/RegistryUtil';
import * as RegistryValidatorActions from 'registry/RegistryValidatorActions';
import {FileInfo, openSetCollectionModal} from 'registry/SetCollectionModal';
import {ListableItem} from 'search/SearchConstants';
import EntityStore from 'stores/EntityStore';
import * as LegacyModalContainer from 'ui-library/LegacyModalContainer';
import legacyRunModal from 'ui-library/legacyRunModal';
import APIUtil from 'util/APIUtil';
import copyToClipboard from 'util/clipboard/copyToClipboard';
import * as modals from 'util/Modals';
import * as ShortcutUtil from 'util/ShortcutUtil';
import {BasicEvent} from 'util/Types';
import * as WorkflowActions from 'workflows/WorkflowActions';
import {dispatchRemoveWorklistItems} from 'worklists/WorklistActions';

import FileBrowserActions, {FileOpenParams} from './FileBrowserActions';
import FinderUtil from './FinderUtil';
import {confirmUngroupFolder, ungroupFolder} from './FolderActions';
import FolderSelectorModalClass, {FolderSelectorModalOptions} from './FolderSelectorModal';
import {FolderSettingsModalWrapper as FolderSettingsModal} from './FolderSettingsModal';
import HideProjectModalClass from './HideProjectModal';
import {ProjectSettingsModal, ProjectSettingsModalProps} from './ProjectSettingsModal';

const {INVENTORY_SECTION, NOTEBOOK_SECTION} = FileBrowserConstants;

const {REGISTRY_TYPE} = SourceConstants;

/** Permission fields read from heterogeneous legacy FileMenu payloads. */
interface FileMenuPermissions extends Partial<
  Pick<
    Permissions,
    | 'admin'
    | 'appendable'
    | 'archivable'
    | 'deletable'
    | 'readable'
    | 'unarchivable'
    | 'unregisterable'
    | 'writable'
  >
> {}

/** Legacy owner shape used to construct registry settings URLs. */
interface FileMenuOwner {
  url_identifier: string;
}

/** Source fields that may be embedded in a FileMenu file or folder. */
interface FileMenuSource {
  archived?: boolean;
  disablePersonalCollections?: boolean;
  hidden?: boolean;
  id?: string;
  name?: string;
  permissions?: FileMenuPermissions;
  rootFolder?: object;
  sourceType?: string;
  s_owner?: FileMenuOwner;
  url?: string;
}

/** Parent-folder fields read by the legacy normalization helpers. */
interface FileMenuFolderReference {
  api_identifier?: string;
  id?: string | number;
  source?: FileMenuSource;
  type?: string;
  url?: string;
}

/** Parent-entry reference supplied by reaction listing payloads. */
interface FileMenuReactionEntry {
  __typename?: string;
  id?: string;
}

/** Common structural surface shared by all legacy FileMenu producers. */
interface FileMenuFile {
  api_identifier?: string;
  archiveData?: MaybeArchivableItem['archiveData'];
  archiveRecord?: MaybeArchivableItem['archiveRecord'];
  archived?: boolean;
  entry?: FileMenuReactionEntry | null;
  folder?: Partial<FileMenuFolderReference> | null;
  hidden?: boolean;
  id: string;
  name: string;
  parent?: Partial<FileMenuFolderReference> | null;
  permissions?: FileMenuPermissions;
  projectFolderId?: string;
  source?: FileMenuSource;
  sourceType?: string;
  s_owner?: FileMenuOwner;
  tagSchema?: TagSchema | null;
  type?: string;
  url?: string;
  worklistId?: string | null;
  writable?: boolean;
}

/** Legacy folder payload whose primary identifier is still numeric. */
interface NumericIdFileMenuFolder extends Omit<FileMenuFile, 'id'> {
  api_identifier: string;
  id: number;
}

/** Minimal normalized folder shape historically passed to navigation APIs. */
interface NormalizedFileMenuFolder {
  api_identifier: string;
  id: string;
  source: FileMenuSource;
  type: string;
  url: string;
}

/** Actionable context-menu item produced by FileMenu. */
interface FileMenuItem {
  click?: () => unknown;
  dataTestAttrs?: {
    component: string;
    element: string;
  };
  disabled?: boolean;
  hide?: boolean;
  name: string;
  tooltip?: string | null;
}

/** FileMenu output element, including the legacy separator sentinel. */
type FileMenuOption = FileMenuItem | '-';

/** Inputs accepted by the legacy FileMenu API. */
interface FileMenuOptions<TFile extends FileMenuFile> {
  closeCallback?: () => void;
  file: TFile;
  finderId?: string;
  handleQuickEdit?: ((file: TFile) => void) | null;
  isListing?: boolean;
}

/** Public methods exposed by the mutable legacy FileMenu singleton. */
interface FileMenuApi {
  _getMenu<TFile extends FileMenuFile>(options: FileMenuOptions<TFile>): Array<FileMenuOption>;
  open<TFile extends FileMenuFile>(e: BasicEvent, options: FileMenuOptions<TFile>): void;
}

/** Keys used to select and order FileMenu entries. */
type FileMenuOptionName =
  | '-'
  | 'addToWorkspace'
  | 'archive'
  | 'changeCollection'
  | 'copy'
  | 'copyApiId'
  | 'deleteFile'
  | 'deleteProject'
  | 'expand'
  | 'export'
  | 'hide'
  | 'manageAccess'
  | 'move'
  | 'openEnclosingFolder'
  | 'openReaction'
  | 'openWorkflow'
  | 'quickEdit'
  | 'register'
  | 'removeFromWorklist'
  | 'rename'
  | 'settings'
  | 'ungroup'
  | 'unhide'
  | 'unarchive'
  | 'unregister';

/** Rename payload accepted by the existing FileBrowser action. */
interface LegacyRenameFileOptions {
  newName: string;
  notifyOnSuccess?: boolean;
  oldName?: string;
  parentFolderId?: string;
}

/** Move payload retaining the legacy tag-schema field ignored by the current action. */
interface LegacyMoveItemsWithDataModsOptions {
  hasRegisteredItems?: boolean;
  parentFolderIds: Array<string>;
  tagSchemaId?: string | null;
}

/** Folder shape guaranteed by the existing pre-ungroup parent assertion. */
type StringIDFolderWithParentName = FolderConstants.StringIDFolder & {parent: {name: string}};

function _normalizedFolder(file: FileMenuFile | NumericIdFileMenuFolder): NormalizedFileMenuFolder {
  const apiId = typeof file.id === 'string' ? file.id : (file.api_identifier as string);
  switch (APIUtil.apiIdToType(apiId)) {
    case ModelTypeConstants.FOLDER:
      return {
        id: apiId,
        api_identifier: apiId,
        url: file.url,
        source: file.source,
        type: file.type,
      } as NormalizedFileMenuFolder;
    case ModelTypeConstants.SOURCE:
      return FinderUtil.sourceToRootFolder(file as unknown as SourceSummary) as NormalizedFileMenuFolder;
    default:
      throw new Error('Unable to normalize non-folder type');
  }
}

function _parentFolder(file: FileMenuFile): NormalizedFileMenuFolder | null {
  switch (APIUtil.apiIdToType(file.id)) {
    case ModelTypeConstants.FOLDER:
      if (file.parent != null) {
        return {
          id: file.parent.api_identifier,
          api_identifier: file.parent.api_identifier,
          url: file.parent.url,
          source: file.parent.source,
          type: file.parent.type,
        } as NormalizedFileMenuFolder;
      } else {
        return null;
      }
    default:
      if (file.folder != null) {
        return {
          // Fallback to regular `.id` in the case that the file is directly in a project
          id: file.folder.api_identifier ?? file.folder.id,
          api_identifier: file.folder.api_identifier,
          url: file.folder.url,
          source: file.folder.source,
          type: file.folder.type,
        } as NormalizedFileMenuFolder;
      } else {
        return null;
      }
  }
}

function expandFolderOnClick(folder: NormalizedFileMenuFolder, finderId?: string): void {
  SidepanelActions.expand();
  getStore().dispatch(
    SidepanelReduxActions.listFolder(
      // The legacy normalized folder shape is sufficient for this action at runtime.
      folder as FolderConstants.StringIDFolder
    )
  );
}

function getProjectSettingsTooltip(isProject: boolean, isProjectArchived: boolean): string | null {
  if (isProject && isProjectArchived) {
    return 'Cannot change settings of archived projects.';
  }
  return null;
}

function _makeMenu<TFile extends FileMenuFile>(
  list: Array<FileMenuOptionName>,
  {file, isListing, finderId, handleQuickEdit}: FileMenuOptions<TFile>
): Array<FileMenuOption> {
  let type = APIUtil.apiIdToType(file.id);
  // If root folder, treat as project.
  if (type === ModelTypeConstants.FOLDER && file.parent == null) {
    type = ModelTypeConstants.SOURCE;
    // Root folders carry their source payload in this legacy representation.
    file = {...file.source, permissions: file.permissions} as unknown as TFile;
  }
  const hasWriteAuth = file.writable || (file.permissions != null ? file.permissions.writable : undefined);
  const hasAppendAuth = file.permissions && file.permissions.appendable;
  const hasArchiveAuth = file.permissions && file.permissions.archivable;
  const hasUnarchiveAuth = file.permissions && file.permissions.unarchivable;
  const hasDeleteAuth = file.permissions && file.permissions.deletable;
  const hasUnregisterAuth = file.permissions && file.permissions.unregisterable;

  const currentUser = EntityStore.currentUser();
  const isSource = type === ModelTypeConstants.SOURCE;
  const isRegistry = isSource && RegistryUtil.isRegistry(file as {sourceType: string});
  const isShortcut = isSource
    ? false
    : ShortcutUtil.shouldShowShortcut(file as ShortcutUtil.ShouldShowShortcutItem, finderId);
  let parentFolderId: string | null | undefined;
  if (isShortcut) {
    parentFolderId = file.projectFolderId;
  } else {
    parentFolderId = _parentFolder(file) ? (_parentFolder(file) as NormalizedFileMenuFolder).id : null;
  }
  const parentRegistry = _parentFolder(file)
    ? (_parentFolder(file) as NormalizedFileMenuFolder).source
    : null;
  const isRegistered = parentRegistry && parentRegistry.sourceType === ModelTypeConstants.REGISTRY;
  const featureItemState = {
    isRegistered,
    isBiologicsOwned: isBiologicsOwnedItem(file),
  };
  const isFolderContainable = APIUtil.isFolderContainable(file.id);

  const isProject = isSource && _normalizedFolder(file).source.sourceType === ModelTypeConstants.PROJECT;
  const isProjectArchived = Boolean(
    isProject && isArchived(_normalizedFolder(file).source as unknown as MaybeArchivableItem)
  );

  const isFolder = type === ModelTypeConstants.FOLDER;

  const fullMenu: Record<FileMenuOptionName, FileMenuOption> = {
    rename: {
      name: 'Rename',
      click() {
        const oldName = file.name;
        modals
          .prompt(
            'Rename',
            oldName,
            // This legacy prompt accepts the entered string as its truthy validation result.
            (value: string) => value as unknown as boolean
          )
          .done((newName) => {
            FileBrowserActions.renameFileWithDataMods(
              file.id,
              isRegistered as boolean,
              // A successful prompt resolves with the legacy rename payload shape.
              {
                oldName,
                newName,
                parentFolderId,
                notifyOnSuccess: true,
              } as LegacyRenameFileOptions
            );
          });
      },
      disabled: !hasWriteAuth,
      hide: APIUtil.isDataset(file.id) || !isFolderContainable,
    },

    quickEdit: {
      name: 'Edit',
      click() {
        (handleQuickEdit as (file: TFile) => void)(file);
      },
      hide: handleQuickEdit == null || type === ModelTypeConstants.FOLDER || isProject,
    },

    removeFromWorklist: {
      name: 'Remove from worklist',
      click() {
        dispatchRemoveWorklistItems(file.worklistId as string, [file.id], {
          refreshWorklistItemsSearch: true,
          refreshRecentWorklists: true,
        });
      },
      hide: file.worklistId == null,
    },

    deleteFile: {
      name: 'Delete',
      click() {
        const deleteDescription = (
          <span>
            {`the ${type === ModelTypeConstants.FOLDER ? 'folder' : 'file'} `}
            <strong>{file.name}</strong>
          </span>
        );
        FilesForDeleteModalClass.openForFileDelete(
          {deleteDescription},
          [file as unknown as ListableItem],
          finderId as string
        );
      },
      disabled: !hasDeleteAuth,
      hide: !isFolderContainable || !BenchlingConfig.ENABLE_DELETE || APIUtil.isDataset(file.id),
      tooltip: hasDeleteAuth
        ? null
        : DeleteUtil.getUndeletableTooltipTitle({isArchived: isArchived(file as MaybeArchivableItem)}),
    },

    deleteProject: {
      name: 'Delete',
      click() {
        const {source} = _normalizedFolder(file);
        FilesForDeleteModalClass.open({
          fileIds: [(source.rootFolder as {api_identifier: string}).api_identifier],
          doDelete: () =>
            SourceActions.deleteSource(source.id as string)
              .done((response) => {
                notifications.success(
                  <>
                    Successfully deleted <strong>{source.name}</strong>
                  </>
                );
              })
              .fail(notifications.notifyError),
          deleteDescription: (
            <span>
              the project <strong>{source.name}</strong>
            </span>
          ),
        });
      },
      disabled: !hasDeleteAuth,
      hide: !isProject || !BenchlingConfig.ENABLE_DELETE,
      tooltip: hasDeleteAuth ? null : DeleteUtil.getUndeletableTooltipTitle({isArchived: isProjectArchived}),
    },

    archive: {
      name: 'Archive',
      click() {
        ArchiveModal.open({
          items: [file],
          // The archive modal invokes the existing action with the compatible legacy option shape.
          onArchive: getArchiveAction([
            file.id,
          ]) as ArchiveModal.ArchiveModalPropsWithoutCloseCallback['onArchive'],
          shouldDetectShortcuts: ShortcutUtil.shouldDetectShortcuts(finderId as string),
        });
      },
      disabled: !hasArchiveAuth,
      hide: !isArchivable(file) || isArchived(file) || isRegistry,
      dataTestAttrs: {component: 'FileMenu', element: 'archive'},
    },

    unarchive: {
      name: 'Unarchive',
      click() {
        getUnarchiveAction([file.id])([file.id], {hasRegisteredItems: isRegistered as boolean});
      },
      disabled: !hasUnarchiveAuth,
      hide: !isArchived(file),
    },

    move: {
      name: 'Move to folder',
      click() {
        function callback(folderId: string, sourceId: string | null, tagSchemaId?: string | null): void {
          FileBrowserActions.moveItemsWithDataMods(
            [file.id],
            folderId,
            // The legacy action consumes tagSchemaId despite its narrower declared options type.
            {
              parentFolderIds: [parentFolderId as string],
              tagSchemaId,
              hasRegisteredItems: isRegistered as boolean,
            } as LegacyMoveItemsWithDataModsOptions,
            () => isShortcut
          );
        }
        FolderSelectorModalClass.openForMove(
          // The selector accepts this legacy currentTagSchema option at runtime.
          {
            currentTagSchema: file.tagSchema,
            initialSelectedFolderId: parentFolderId,
            itemsToMove: [{id: file.api_identifier ?? file.id}],
            showInventory: true,
            showNotebook: true,
          } as FolderSelectorModalOptions,
          callback
        );
      },
      hide:
        (isRegistered && !isShortcut) ||
        !isFolderContainable ||
        APIUtil.isDataset(file.id) ||
        !isFeatureEnabled(
          // FileMenu's legacy structural item shape is compatible with capability evaluation.
          {feature: StandardFeature.MOVE, item: file, itemState: featureItemState} as FeatureDefinition
        ),
    },

    copy: {
      name: 'Copy to...',
      click() {
        let showInventory, showNotebook;

        function callback(folderId: string): void {
          FileBrowserActions.copyItems([file.id], folderId);
        }

        if (type === ModelTypeConstants.FOLDER) {
          showInventory = file.type === FolderConstants.Type.INVENTORY;
          showNotebook = file.type === FolderConstants.Type.NOTEBOOK;
        } else {
          showInventory = Array.from(getRegistrySupportedTypes()).includes(type as RegistrySupportedType);
          showNotebook = Array.from(NOTEBOOK_ITEMS).includes(type);
        }
        // For entries we show a clone modal with entry schema options
        if (APIUtil.isEntry(file.id) && BenchlingConfig.ELN_ENABLE_SCHEMA_ON_ENTRY_CREATE_MODAL) {
          EntryDAO.get(file.id).then((entry) => {
            legacyRunModal(CloneModal, {
              modelType: ModelTypeConstants.ENTRY,
              id: entry!.id,
              versionId: entry!.latestVersionId,
              initialName: `Copy of ${entry!.name}`,
            });
          });
        } else {
          FolderSelectorModalClass.openForCopy(
            {
              initialSelectedFolderId: isRegistered ? null : parentFolderId,
              showInventory,
              showNotebook,
            } as FolderSelectorModalOptions,
            callback
          );
        }
      },
      hide:
        !isFolderContainable ||
        !isFeatureEnabled(
          // FileMenu's legacy structural item shape is compatible with capability evaluation.
          {feature: StandardFeature.CREATE, item: file, itemState: featureItemState} as FeatureDefinition
        ) ||
        (!isFolder && !COPYABLE_FOLDER_ITEMS.includes(APIUtil.apiIdToType(file.id))),
    },

    copyApiId: {
      name: 'Copy API ID',
      click() {
        copyToClipboard(file.id, {showToastOnSuccess: true});
      },
      hide: !preferences.get('ENABLE_COPY_API_ID'),
    },

    ungroup: {
      name: 'Ungroup...',
      click() {
        const folder = normalizeFolder(
          file as unknown as FolderConstants.NumberIDFolder | FolderConstants.StringIDFolder
        );
        assert(APIUtil.apiIdToType(file.id) === ModelTypeConstants.FOLDER, 'File must be a folder');
        assert(_parentFolder(file) != null, 'Folder must have a parent');

        confirmUngroupFolder(
          // The preceding legacy assertion guarantees the normalized folder has a parent.
          folder as StringIDFolderWithParentName
        ).done(() => {
          ungroupFolder(folder as StringIDFolderWithParentName);
        });
      },
      hide:
        !isFolder ||
        file.hidden ||
        file.archived ||
        _parentFolder(file) == null ||
        !BenchlingConfig.NAV_ENABLE_FOLDER_UNGROUP_TOOL,
    },

    changeCollection: {
      name: 'Change collection...',
      click() {
        return (openSetCollectionModal as (props: {files: Array<FileInfo>}) => unknown)({
          files: [file],
        });
      },
      hide: !isRegistered || parentRegistry.disablePersonalCollections || !hasAppendAuth,
    },

    expand: {
      name: 'Expand',
      click() {
        expandFolderOnClick(_normalizedFolder(file), finderId);
      },
      hide: ![ModelTypeConstants.FOLDER, ModelTypeConstants.SOURCE].includes(type),
    },

    register: {
      name: 'Register',
      click() {
        RegistryValidatorActions.openRegistryValidatorModal([file as unknown as FinderResult]);
      },
      disabled: !hasWriteAuth,
      hide:
        isRegistered ||
        isShortcut ||
        !(
          APIUtil.isBiologicalEntity(file.id) &&
          isFeatureEnabled({feature: RegistryFeature.REGISTRY_REGISTER})
        ),
    },

    unregister: {
      name: 'Unregister',
      click() {
        function callback(folderId: string, sourceId: string | null, tagSchemaId?: string | null): void {
          RegistryActions.unregisterWithDataMods([file.id], folderId, [parentFolderId as string]);
        }

        FolderSelectorModalClass.openForMove(
          // The selector accepts this legacy currentTagSchema option at runtime.
          {
            currentTagSchema: file.tagSchema,
            showInventory: true,
            showNotebook: false,
          } as FolderSelectorModalOptions,
          callback
        );
      },
      disabled: !hasUnregisterAuth,
      hide:
        (!isRegistered && !isShortcut) || !isFeatureEnabled({feature: RegistryFeature.REGISTRY_UNREGISTER}),
    },

    openEnclosingFolder: {
      name: 'Open enclosing folder',
      async click() {
        let folder;
        let section;
        if (isShortcut) {
          folder = await ShortcutUtil.projectFolder(parentFolderId as string);
          if (folder == null) {
            // If we don't have access to project folder, open original parent folder
            folder = _parentFolder(file);
          }
        } else {
          folder = _parentFolder(file);
        }
        folder = _normalizedFolder(folder as FileMenuFile);
        if (type === ModelTypeConstants.FOLDER) {
          section = FolderConstants.FolderSection.ALL;
        } else {
          section = APIUtil.isBiologicalEntity(file.id) ? INVENTORY_SECTION : NOTEBOOK_SECTION;
        }
        listFolderSection(
          // The legacy normalized folder shape is sufficient for listing this section.
          folder as FolderConstants.NumberIDFolder | FolderConstants.StringIDFolder,
          section
        );
      },
      hide: parentFolderId == null || isListing,
    },

    addToWorkspace: {
      name: 'Open',
      click() {
        FileBrowserActions.openFile(file.id, {
          itemState: featureItemState,
          open: true,
        } as FileOpenParams);
      },
      hide:
        [
          ModelTypeConstants.FOLDER,
          ModelTypeConstants.SOURCE,
          ModelTypeConstants.WORKFLOW,
          ModelTypeConstants.REACTION,
          ...(!BenchlingConfig.ENABLE_CANVAS_SAVE_TO_FOLDER
            ? [ModelTypeConstants.CANVAS_FOLDER_ARTIFACT]
            : []),
        ].includes(type) ||
        !isFeatureEnabled(
          // FileMenu's legacy structural item shape is compatible with capability evaluation.
          {feature: StandardFeature.OPEN, item: file, itemState: featureItemState} as FeatureDefinition
        ),
    },
    openWorkflow: {
      name: 'Open',
      click() {
        WorkflowActions.routeToWorkflow(file.id);
      },
      hide: type !== ModelTypeConstants.WORKFLOW,
    },
    openReaction: {
      name: 'Open',
      click() {
        // Reactions don't have their own detail page — navigate to the parent entry instead.
        const entryId = file.entry?.__typename === 'EntryNode' ? file.entry.id : null;
        if (entryId) {
          FileBrowserActions.openFile(entryId);
        }
      },
      hide:
        type !== ModelTypeConstants.REACTION ||
        !isFeatureEnabled(
          // FileMenu's legacy structural item shape is compatible with capability evaluation.
          {feature: StandardFeature.OPEN, item: file, itemState: featureItemState} as FeatureDefinition
        ),
    },
    settings: {
      name: 'Settings',
      click() {
        switch (type) {
          case ModelTypeConstants.FOLDER:
            LegacyModalContainer.open(
              FolderSettingsModal,
              <FolderSettingsModal
                folderId={file.id}
                onRequestClose={
                  function () {
                    return (LegacyModalContainer.close as (key: unknown) => unknown)(FolderSettingsModal);
                  } as unknown as () => void
                }
                isReadOnly={!(file.permissions?.writable ?? true)}
              />
            );
            break;
          case ModelTypeConstants.SOURCE:
            if (file.sourceType === REGISTRY_TYPE) {
              BenchlingUtil.navigate(
                null,
                RegistryUtil.getRegistrySettingsUrl((file.s_owner as FileMenuOwner).url_identifier, file.id)
              );
            } else {
              const permissions = _normalizedFolder(file).source.permissions;
              LegacyModalContainer.open(
                ProjectSettingsModal,
                React.createElement(
                  // The legacy caller still supplies the inert permissions prop.
                  ProjectSettingsModal as React.ComponentType<
                    Omit<ProjectSettingsModalProps, 'onRequestClose'> & {
                      onRequestClose: () => unknown;
                      permissions: FileMenuPermissions | undefined;
                    }
                  >,
                  {
                    permissions,
                    sourceId: _normalizedFolder(file).source.id as string,
                    onRequestClose: function onRequestClose() {
                      return (LegacyModalContainer.close as (key: unknown) => unknown)(ProjectSettingsModal);
                    },
                  }
                )
              );
            }
            break;
          default:
            throw new Error(`Unable to manage settings of a file of type ${type}`);
        }
      },
      hide: ![ModelTypeConstants.FOLDER, ModelTypeConstants.SOURCE].includes(type),
      disabled: ![ModelTypeConstants.FOLDER, ModelTypeConstants.SOURCE].includes(type),
      tooltip: getProjectSettingsTooltip(isProject, isProjectArchived),
      dataTestAttrs: {component: 'FileMenu', element: 'settings'},
    },

    export: {
      name: 'Export',
      click() {
        if (type === ModelTypeConstants.SOURCE && file.sourceType === REGISTRY_TYPE) {
          ExportModalClass.open({
            exportType: ExportConstants.TYPE.REGISTRY,
            registry: file,
          });
          return;
        }
        ExportModalClass.open({folderIds: [_normalizedFolder(file).id]});
      },
      hide:
        !BenchlingConfig.ENABLE_EXPORTS ||
        ![ModelTypeConstants.FOLDER, ModelTypeConstants.SOURCE].includes(type),
      disabled: currentUser == null,
      dataTestAttrs: {component: 'FileMenu', element: 'export'},
    },

    hide: {
      name: 'Hide',
      click() {
        const folder = _normalizedFolder(file);

        LegacyModalContainer.open(
          HideProjectModalClass,
          <HideProjectModalClass
            initialFolders={[
              // The legacy normalized folder shape is sufficient for this modal.
              folder as React.ComponentProps<typeof HideProjectModalClass>['initialFolders'][number],
            ]}
            onRequestClose={function () {
              LegacyModalContainer.close(HideProjectModalClass);
            }}
          />
        );
      },
      hide: !isProject || file.hidden || file.archived,
      disabled: currentUser == null,
    },

    unhide: {
      name: 'Unhide',
      click() {
        return (FileBrowserActions.unhideSource as (sourceId: string) => unknown)(
          _normalizedFolder(file).source.id as string
        );
      },
      hide: !isProject || !(file.hidden || file.archived),
      disabled: currentUser == null || file.archived,
      tooltip: currentUser != null && file.archived ? 'Archived projects are hidden for all users.' : null,
    },

    manageAccess: {
      name: 'Manage access',
      click() {
        switch (type) {
          case ModelTypeConstants.SOURCE: {
            const source = _normalizedFolder(file).source;
            SourceActions.openSavingCollaborationManagementModal(source as Source);
            break;
          }
          case ModelTypeConstants.FOLDER: {
            PoliceableActions.openSavingCollaborationManagementModal(_normalizedFolder(file).id);
            break;
          }
          default:
            PoliceableActions.openSavingCollaborationManagementModal(file.id);
        }
      },
      hide: !(
        isCollaboratable(
          isFolder ? (_normalizedFolder(file) as MaybeCoreObject) : (file as MaybeCoreObject)
        ) || isProject
      ),
      disabled: currentUser == null,
      dataTestAttrs: {component: 'FileMenu', element: 'manageAccess'},
    },

    '-': '-',
  };
  return Array.from(list).map((option) => fullMenu[option]);
}

var FileMenu: FileMenuApi = {
  _getMenu(options) {
    const list: Array<FileMenuOptionName> = [
      'expand',
      'openEnclosingFolder',
      'addToWorkspace',
      'openWorkflow',
      'openReaction',
      '-',
      'move',
      'copy',
      'ungroup',
      'changeCollection',
      'register',
      'unregister',
      'removeFromWorklist',
      '-',
      'rename',
      'quickEdit',
      'deleteFile',
      'deleteProject',
      'archive',
      'unarchive',
      '-',
      'settings',
      'manageAccess',
      'export',
      'hide',
      'unhide',
      '-',
      'copyApiId',
    ];
    return _makeMenu(list, options);
  },

  open(e, options) {
    const menu = FileMenu._getMenu(options);
    const opened = contextmenu.view.open(e.nativeEvent, menu);
    if (opened && options.closeCallback != null) {
      contextmenu.view.once('close', options.closeCallback);
    }
  },
};

export default FileMenu;
